module.exports = __webpack_public_path__ + "static/img/default.06ba5fe5.png";